<h2>{{'tutorial_title_1' | translate}}</h2>
<p>{{'tutorial_text_1' | translate}}</p>
<h3>{{'tutorial_title_2' | translate}}</h3>
<ul>
  <li>{{'tutorial_bullet_1' | translate}}</li>
  <li>{{'tutorial_bullet_2' | translate}}</li>
  <li>{{'tutorial_bullet_3' | translate}}</li>
  <li>{{'tutorial_bullet_4' | translate}}</li>
  <li>{{'tutorial_bullet_5' | translate}}</li>
</ul>
<h3>{{'tutorial_title_3' | translate}}</h3>
<p>{{'tutorial_text_2' | translate}}</p>
<p>{{'tutorial_text_3' | translate}}</p>

<div class="container-button-center">
  <button matButton="filled"
    color="accent"
    class="button-rounded-center"
    (click)="onClickContinue()">
    {{'tutorial_start' | translate}}
  </button>
</div>